import { FunctionComponent, lazy, LazyExoticComponent } from 'react';

export interface ConfirmationContentProps {
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmationComponentsMap = new Map<
    string,
    LazyExoticComponent<FunctionComponent<ConfirmationContentProps>>
>([['LinksList', lazy<any>(() => import('components/common/form/confirmation/content/LinksList'))]]);
